export function PrivacyPolicy() {
  return (
    <article className="legal-body">
      <h1>Integritetspolicy</h1>
      <p className="updated">Senast uppdaterad: 2026-04-07</p>

      <p>
        Partikampen ("appen", "vi") är ett mobilspel utvecklat av en enskild utvecklare. Den här policyn beskriver vilka personuppgifter vi samlar in, varför, och dina rättigheter som användare. Eftersom appen riktar sig till svenska användare gäller EU:s dataskyddsförordning (GDPR).
      </p>

      <h2>1. Personuppgiftsansvarig</h2>
      <p>
        Lars Jensen<br />
        E-post: <a href="mailto:kontakt@partikampen.se">kontakt@partikampen.se</a>
      </p>

      <h2>2. Vilka uppgifter vi samlar in</h2>
      <ul>
        <li><strong>Anonym användar-ID</strong> – Vi använder Firebase Anonymous Authentication. Ingen e-postadress, inget namn och inget telefonnummer samlas in. Du tilldelas ett slumpmässigt ID som lagras lokalt på din enhet och i vår databas.</li>
        <li><strong>GPS-position</strong> – Appen begär platsåtkomst för att avgöra vilket kommunalvaldistrikt du befinner dig i. Din position används uteslutande i realtid för spellogiken och lagras aldrig i vår databas.</li>
        <li><strong>Speldata</strong> – Ditt valda parti, ditt partistödssaldo, vilka distrikt du erövrat samt anhängarantal per distrikt lagras i Firebase Firestore för att möjliggöra realtidsmultiplayerspel.</li>
        <li><strong>Push-token</strong> – Om du godkänner aviseringar lagrar vi din Expo Push Token för att kunna skicka spelrelaterade notifikationer (t.ex. "ditt distrikt attackeras").</li>
      </ul>

      <h2>3. Varför vi behandlar uppgifterna</h2>
      <ul>
        <li><strong>Anonym ID och speldata</strong> – Nödvändigt för att spelet ska fungera: spara ditt framsteg, visa realtidskartan och synkronisera distrikt mellan spelare. Rättslig grund: berättigat intresse (fullgörande av speltjänsten).</li>
        <li><strong>GPS-position</strong> – Nödvändigt för att verifiera att du befinner dig i det distrikt du kampanjar i. Behandlingen sker enbart lokalt på din enhet. Rättslig grund: samtycke (du beviljar platsåtkomst i enhetens behörighetsdialog).</li>
        <li><strong>Push-token</strong> – Används för att skicka spelrelaterade aviseringar. Rättslig grund: samtycke (du godkänner aviseringar i enhetens behörighetsdialog).</li>
      </ul>

      <h2>4. Hur länge vi sparar uppgifterna</h2>
      <p>Ditt anonyma ID och din speldata sparas tills du raderar ditt konto via appen (Profil → Radera mitt konto). Push-token tas bort i samband med kontoradering.</p>

      <h2>5. Delning med tredje part</h2>
      <p>Vi delar inte dina uppgifter med tredje part för marknadsföringsändamål. Vi använder följande underleverantörer:</p>
      <ul>
        <li><strong>Google Firebase</strong> (Firestore, Authentication, Cloud Messaging) – för databas, autentisering och push-notifikationer. Googles dataskyddspolicy: <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noreferrer">firebase.google.com/support/privacy</a></li>
        <li><strong>Expo</strong> – för push-notifikationstjänsten Expo Push. Expos integritetspolicy: <a href="https://expo.dev/privacy" target="_blank" rel="noreferrer">expo.dev/privacy</a></li>
      </ul>

      <h2>6. Dina rättigheter (GDPR)</h2>
      <ul>
        <li><strong>Rätt till radering</strong> – Du kan radera all din data direkt i appen via Profil → Radera mitt konto. Det tar bort ditt användardokument och ditt anonyma konto omedelbart.</li>
        <li><strong>Rätt till tillgång</strong> – Du kan begära en kopia av de personuppgifter vi har om dig genom att kontakta oss på e-postadressen ovan.</li>
        <li><strong>Rätt att återkalla samtycke</strong> – Du kan när som helst återkalla platsåtkomst eller aviseringstillstånd i din enhets inställningar.</li>
        <li><strong>Rätt att klaga</strong> – Du har rätt att lämna in ett klagomål till Integritetsskyddsmyndigheten (IMY): <a href="https://www.imy.se" target="_blank" rel="noreferrer">imy.se</a></li>
      </ul>

      <h2>7. Barn</h2>
      <p>Appen är avsedd för användare i alla åldrar. Vi samlar inte medvetet in uppgifter om barn under 13 år utöver det anonyma ID som krävs för att spelet ska fungera. Ingen information som kan identifiera ett barn samlas in.</p>

      <h2>8. Ändringar i policyn</h2>
      <p>Om vi gör väsentliga ändringar i den här policyn uppdateras datumet överst på sidan. Vid betydande förändringar kan vi även meddela dig via ett aviseringsmeddelande i appen.</p>

      <h2>9. Kontakt</h2>
      <p>Frågor om integritet besvaras på: <a href="mailto:kontakt@partikampen.se">kontakt@partikampen.se</a></p>
    </article>
  );
}
